// Paths only name entries in the in-memory file table (see node-fs.ts).
export const join = (...parts: string[]): string => parts.filter(Boolean).join('/');
